import pica from 'pica';

const GALLERY_IMAGE_VARIANTS = [
  { name: 'desktop', width: 2000, height: 1000 },
  { name: 'mobile', width: 900, height: 1300 },
];

const GALLERY_IMAGE_BACKGROUND = '#EAD9CD';

function canvasToWebP(resizer, canvas) {
  return resizer.toBlob(canvas, 'image/webp', 0.9).then((blob) => {
    if (!blob || blob.type !== 'image/webp') {
      throw new Error('WebP export is not supported by this browser.');
    }
    return blob;
  });
}

async function createVariant(resizer, bitmap, variant) {
  const scale = Math.min(variant.width / bitmap.width, variant.height / bitmap.height);
  const imageWidth = Math.max(1, Math.round(bitmap.width * scale));
  const imageHeight = Math.max(1, Math.round(bitmap.height * scale));
  const resizedImage = document.createElement('canvas');
  resizedImage.width = imageWidth;
  resizedImage.height = imageHeight;

  const output = document.createElement('canvas');
  output.width = variant.width;
  output.height = variant.height;

  try {
    await resizer.resize(bitmap, resizedImage);
    const context = output.getContext('2d');
    if (!context) throw new Error('Could not create an image canvas.');

    context.fillStyle = GALLERY_IMAGE_BACKGROUND;
    context.fillRect(0, 0, variant.width, variant.height);
    context.drawImage(
      resizedImage,
      Math.round((variant.width - imageWidth) / 2),
      Math.round((variant.height - imageHeight) / 2),
      imageWidth,
      imageHeight,
    );

    return await canvasToWebP(resizer, output);
  } finally {
    resizedImage.width = 0;
    resizedImage.height = 0;
    output.width = 0;
    output.height = 0;
  }
}

export async function createGalleryImageVariants(file) {
  if (typeof createImageBitmap !== 'function') {
    throw new Error('Image processing is not supported by this browser.');
  }

  const bitmap = await createImageBitmap(file);
  const resizer = pica({ concurrency: 1 });

  try {
    const variants = {};
    for (const variant of GALLERY_IMAGE_VARIANTS) {
      variants[variant.name] = await createVariant(resizer, bitmap, variant);
    }
    return variants;
  } finally {
    bitmap.close();
  }
}
